import type { Enums } from "../types";

/**
 * This function returns the color for the given calculation state.
 * @param state
 * @returns
 */
export function getCalculationStateColor(state: Enums<"calculationState">): Enums<"color"> {
	switch (state) {
		case "pending":
			return "accent";
		case "locked":
			return "emerald";
	}
}
